 import { gsap } from "gsap";

const blocks = () => {




 /* SLider Loop testuale */

    if ($('.blocco_text_slider')[0]){

        const txt_slider = document.querySelectorAll(".swiper_slider_text");
        
        txt_slider.forEach((text) => {
            
            const TextSlideSpeed = text.dataset.sliderspeed;
            const TextSlideDelay = text.dataset.sliderdelay;
            
            const slider = new Swiper('.swiper_slider_text', {
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 0,
                speed: 4000,
                allowTouchMove: false,

                autoplay: {
                delay: 0,
                disableOnInteraction: false,
                },

                cssMode: false,
            });

        });


        
    }
    if ($('.blocco_slider')[0]) {
    const slider = new Swiper('.blocco_slider', {
                loop: true,
                slidesPerView: 1.3,
                spaceBetween: 20,
                speed: 4000,
                allowTouchMove: true,
                cssMode: false,
                autoHeight:false,
            });
    }


    if ($('.blocco_pannello_anteprima')[0]) {
    window.addEventListener("load", () => {

        document.querySelectorAll('.js-profile-panel').forEach(panel => {

            const wrapper  = panel.querySelector('.profile-panel__bodywrapper');
            const inner    = panel.querySelector('.profile-panel__body-inner');
            const excerpt  = panel.querySelector('.profile-panel__excerpt');
            const full     = panel.querySelector('.profile-panel__full');
            const toggle   = panel.querySelector('.profile-panel__toggle');
            const image    = panel.querySelector('img');

            let isOpen = false;

            function getHeights() {
                return {
                    collapsed: excerpt.scrollHeight,
                    expanded: inner.scrollHeight
                };
            }

            const { collapsed } = getHeights();

            gsap.set(wrapper, { height: collapsed });
            gsap.set(full, { opacity: 0, y: 20 });

            toggle.addEventListener('click', () => {

                const { collapsed, expanded } = getHeights();

                const tl = gsap.timeline({
                    defaults: { ease: "power3.inOut" }
                });

                if (!isOpen) {

                    tl.to(wrapper, {
                        height: expanded,
                        duration: 0.9
                    })
                    .to(full, {
                        opacity: 1,
                        y: 0,
                        duration: 0.6
                    }, "<")
                    .to(image, {
                        scale: 1.03,
                        duration: 0.8,
                        ease: "power2.out"
                    }, "<");

                    panel.classList.add('is-open');
                    toggle.textContent = "Leggi meno";

                } else {

                    tl.to(full, {
                        opacity: 0,
                        y: 20,
                        duration: 0.4
                    })
                    .to(wrapper, {
                        height: collapsed,
                        duration: 0.7
                    }, "<")
                    .to(image, {
                        scale: 1,
                        duration: 0.5
                    }, "<");

                    panel.classList.remove('is-open');
                    toggle.textContent = "Leggi tutto";
                }

                isOpen = !isOpen;

            });

        });

    });


    }

    if ($('.blocco_modale')[0]) {
        document.addEventListener('DOMContentLoaded', function () {

            console.log('ci siamo nel blocco modlae');
        const params = new URLSearchParams(window.location.search);
        const modalSlug = params.get('modal');

        if (!modalSlug) return;

        const modalEl = document.querySelector(`[data-modal-slug="${modalSlug}"]`);

        if (modalEl) {
            const modal = new bootstrap.Modal(modalEl);
            modal.show();
        }

    });
    }
    
    // Initialize Lenis
const lenis = new Lenis({
  autoRaf: true,
});

// Listen for the scroll event and log the event data
// lenis.on('scroll', (e) => {
//   console.log(e);
// });

};

export default blocks;